import { protectRoute } from 'components/route-access/route-access'
import VouchersPage from 'domains/marketing-vouchers/vouchers-page'

const voucher_routes = {
  collapse: true,
  path: '/marketing',
  name: 'Marketing Team',
  icon: 'fas fa-bullhorn text-pink',
  state_key: 'marketing_vouchers_collapse',
  views: [
    {
      path: '/marketing/vouchers',
      name: 'Vouchers',
      miniName: 'V',
      component: VouchersPage,
      layout: '/app',
      allowedRoles: [ 'owner', 'admin', 'marketing' ],
      allowedEmails: [ 'corry.belleandkate@gmail.com' ]
    }
  ]
}

export default { ...voucher_routes, views: voucher_routes.views.map(protectRoute) }
